import { render, staticRenderFns } from "./TotalTestCard.vue?vue&type=template&id=7d0f859c&scoped=true"
import script from "./TotalTestCard.vue?vue&type=script&lang=js"
export * from "./TotalTestCard.vue?vue&type=script&lang=js"
import style0 from "./TotalTestCard.vue?vue&type=style&index=0&id=7d0f859c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f859c",
  null
  
)

export default component.exports